//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { filter } from 'lodash';
import { cloneDeep } from 'lodash';

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const vocabularyInitial = []

export const vocabulary = (state = vocabularyInitial, action) => {
    switch (action.type) {
        case ActionTypes.vocabulary.listVocabularySuccess:
            return action.payload;
        case ActionTypes.vocabulary.updateVocabularySuccess:
            return state.map(x => { if (x.id === action.payload?.id) { return { ...x, ...action.payload }; } return x; });
        case ActionTypes.vocabulary.deleteVocabularySuccess:
            const delv = cloneDeep(state)
            const result = filter(delv,k =>k.id != action.payload.id)
            return result;
        case ActionTypes.vocabulary.listVocabularyFail:
            return state;
        case ActionTypes.vocabulary.createVocabularySuccess:
            return [...state, action.payload];
        default:
            return state;
    }
}